<script setup lang="ts">
    import type { AcademyBadge } from '~/types/academy/baseTraining';
    import { getBadgeIconByType } from '~/utils/academyUtils';

    const props = defineProps<{
        badges: AcademyBadge[];
    }>();

    const { t } = useI18n();

    const MAX_VISIBLE_BADGES = 3;

    function resolveBadgeLabel(badge: AcademyBadge): string | undefined {
        if (badge.displayLabel) {
            return badge.displayLabel;
        }

        if (badge.labelKey) {
            return t(badge.labelKey);
        }

        return undefined;
    }

    const visibleBadges = computed(() =>
        props.badges.slice(0, MAX_VISIBLE_BADGES).map((badge) => ({
            ...badge,
            icon: badge.icon ?? getBadgeIconByType(badge.type),
            label: resolveBadgeLabel(badge)
        }))
    );
</script>

<template>
    <div
        v-if="visibleBadges.length"
        class="teaser-badges"
        aria-label="Kategorien"
    >
        <TeaserBadge
            v-for="badge in visibleBadges"
            :key="badge.type"
            :label="badge.label"
            :icon="badge.icon"
        />
    </div>
</template>

<style scoped lang="scss">
    @import '~/assets/scss/academy/teaser-layout.scss';

    .teaser-badges {
        gap: $spacing--025;

        &.horizontal-only {
            @include teaser-horizontal-layout {
                display: flex;
                position: static;
                flex-direction: row;
                flex-wrap: wrap;
            }
        }

        &.vertical-only {
            display: flex;
            position: absolute;
            max-width: 85%;
            flex-wrap: wrap;
            flex-direction: row-reverse;
            top: calc($spacing + $spacing--05);
            right: calc($spacing + $spacing--05);
        }
    }
</style>
